import Vue from 'vue';

import '@/shared/modules';

import ValidationInput from '@/components/ValidationInput.vue';
import CleaveDate from '@/components/CleaveDate.vue';
import CleaveMoney from '@/components/CleaveMoney.vue';
import CleavePhone from '@/components/CleavePhone.vue';
import DatepickerInput from '@/components/DatepickerInput.vue';
import HelpText from '@/components/HelpText.vue';
import helpers from '@/shared/modules/helpers';
import utils from '@/shared/modules/utils';

Vue.prototype.$h = helpers;
Vue.prototype.$u = utils;

Vue.component('ValidationInput', ValidationInput);
Vue.component('DatepickerInput', DatepickerInput);
Vue.component('CleaveDate', CleaveDate);
Vue.component('CleaveMoney', CleaveMoney);
Vue.component('CleavePhone', CleavePhone);
Vue.component('HelpText', HelpText);
